import PageBreakWidget from './PageBreakWidget';
export default PageBreakWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/PageBreakWidget/index.js